export const cdnUrl = 'https://cdn.veracity.com';
export const cdnStagUrl = 'https://cdnstag.veracity.com';
export const cdnTestUrl = 'https://cdntest.veracity.com';
export const cdnFontsPath = '/common/fonts';
export const cdnUrls = {
    Prod: cdnUrl,
    Stag: cdnStagUrl,
    Test: cdnTestUrl
};
